import { createSlice } from "@reduxjs/toolkit";

const scenariosSlice = createSlice({
  name: "scenarios",
  initialState: {
    selectedScenario: {},
    referenceScenario: {},
    list: [],
    totalsByScenarioId: [],
    setCacheScenario: {
      Pricing: {},
      "Trade Promotions": {},
      "Pricing 2.0": {},
      "Daily Trade Promotions": {},
    },
    setCacheReferenceScenario: {
      Pricing: {},
      "Trade Promotions": {},
      "Pricing 2.0": {},
      "Daily Trade Promotions": {},
    },
    loadingScenario: false,
    cannibalizationRequested: "idle",
  },
  reducers: {
    setSelectedScenario: (state, action) => {
      return {
        ...state,
        selectedScenario: {
          ...state.selectedScenario,
          ...action.payload,
        },
      };
    },
    resetSelectedScenario: (state) => {
      return {
        ...state,
        selectedScenario: {},
      };
    },
    setLoadingScenario: (state, action) => {
      return {
        ...state,
        loadingScenario: action.payload,
      };
    },
    setCacheScenario: (state, action) => {
      return {
        ...state,
        setCacheScenario: { ...state.setCacheScenario, ...action.payload },
      };
    },
    setCacheReferenceScenario: (state, action) => {
      return {
        ...state,
        setCacheReferenceScenario: {
          ...state.setCacheReferenceScenario,
          ...action.payload,
        },
      };
    },
    setReferenceScenario: (state, action) => {
      return {
        ...state,
        referenceScenario: {
          ...state.referenceScenario,
          ...action.payload,
        },
      };
    },
    addScenarioList: (state, action) => {
      return { ...state, list: { ...state.list, ...action.payload } };
    },
    addScenarioTotals: (state, action) => {
      return {
        ...state,
        totalsByScenarioId: { ...state.totalsByScenarioId, ...action.payload },
      };
    },
    deleteScenarioTotals: (state, action) => {
      const newState = state;

      delete newState.totalsByScenarioId[action.payload.scenarioId];

      return newState;
    },
    setScenarioEstimations: (state, action) => {
      const newState = state;

      newState.totalsByScenarioId[action.payload.id].estimations =
        action.payload.estimations;

      return newState;
    },
    setCannibalizationRequested: (state, action) => {
      return {
        ...state,
        cannibalizationRequested: action.payload,
      };
    },
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = scenariosSlice;

// Extract and export each action creator by name
export const {
  setSelectedScenario,
  resetSelectedScenario,
  setReferenceScenario,
  addScenarioList,
  setScenarioEstimations,
  addScenarioTotals,
  deleteScenarioTotals,
  setLoadingScenario,
  setCacheScenario,
  setCacheReferenceScenario,
  setCannibalizationRequested,
} = actions;

// Export the reducer, either as a default or named export
export default reducer;
